import { render, staticRenderFns } from "./DeleteWarning.vue?vue&type=template&id=7aa0ad64&"
import script from "./DeleteWarning.vue?vue&type=script&lang=js&"
export * from "./DeleteWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports